import type React from 'react';

import { useStepOwners } from '@/hooks/createSix/useStepOwners';
import StepOwnersView from '@/components/organism/CreateSix/steps/StepOwners/StepOwners.view';

export interface StepOwnersProps {
  onClose: () => void;
}

function StepOwners(props: StepOwnersProps): React.JSX.Element {
  void props;

  const { state, handlers } = useStepOwners();

  return (
    <StepOwnersView
      selectedOwners={state.selectedOwners}
      candidateOwners={state.candidateOwners}
      searchValue={state.searchValue}
      onSearchValueChange={handlers.handleSearchValueChange}
      onRemoveOwner={handlers.handleRemoveOwner}
      onAddOwner={handlers.handleAddOwner}
    />
  );
}

StepOwners.displayName = 'StepOwners';

export default StepOwners;
